import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../../../common/_common.scss'
import AdviserProfileLanguagePreferences from '../../../../../common/AdviserProfiles/AdviserProfileLanguagePreferences'
import * as styles from './_AdviserProfileLanguagePreferencesEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import { bindActionCreators } from 'redux'
import {
  startEditingLanguages
  , stopEditingLanguages
  , cancelEditingLanguages
  , fetchLanguages
  , languageSelectedChanged
} from './adviserProfileLanguagePreferencesEditorActions'
import PropTypes from 'prop-types';

class adviserProfileLanguagePreferencesEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingLanguages: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingLanguages: PropTypes.func.isRequired,
    stopEditingLanguages: PropTypes.func.isRequired,
    cancelEditingLanguages: PropTypes.func.isRequired,
    fetchLanguages: PropTypes.func.isRequired,
    allLanguages: PropTypes.array.isRequired,
    languageSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    languagePreferenceChanges: PropTypes.array.isRequired
  };

  constructor (props) {
    super(props)
    this.stopEditingLanguagePreferences = this.stopEditingLanguagePreferences.bind(this)
  }

  componentDidMount () {
    this.props.fetchLanguages()
  }

  stopEditingLanguagePreferences () {
    this.props.stopEditingLanguages()
  }

  render () {
    const profile = this.props.profile
    const editingLanguages = this.props.editingLanguages
    const selectedLanguages = profile.languagePreferences

   if (editingLanguages) {
  const allLanguages = this.props.allLanguages.map(language => ({
    ...language,
    selected: selectedLanguages.some(
      selectedLanguage =>
        selectedLanguage.languageId === language.languageId
    )
  }))

  return (
    <div>
      <h4 className={styles['title']}>Languages</h4>

      <form className={styles['form-bottom-margin']}>
        {allLanguages.map(language => (
          <FormCheck
            key={language.languageId}
            type="checkbox"
            checked={language.selected}
            value={language.languageId}
            onChange={() => {
              this.props.languageSelectedChanged(language)
            }}
            label={language.language}
          />
        ))}
      </form>
    </div>
  )
}

    return <div>
      <AdviserProfileLanguagePreferences languages={this.props.languagePreferenceChanges} />
    </div>
  }
}

const mapStateToProps = ({adviserProfileApprovalEditorContainer}) => {
  return {
    editingLanguages: adviserProfileApprovalEditorContainer.languagePreferences.editingLanguages,
    loading: adviserProfileApprovalEditorContainer.languagePreferences.loadingLanguages,
    formIsValid: adviserProfileApprovalEditorContainer.languagePreferences.isInvalid.formIsValid,
    validationstate: adviserProfileApprovalEditorContainer.languagePreferences.isInvalid,
    allLanguages: adviserProfileApprovalEditorContainer.languagePreferences.allLanguages,
    languagePreferenceChanges: adviserProfileApprovalEditorContainer.languagePreferences.profileModifications
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startEditingLanguages: startEditingLanguages,
    stopEditingLanguages: stopEditingLanguages,
    cancelEditingLanguages: cancelEditingLanguages,
    fetchLanguages: fetchLanguages,
    languageSelectedChanged: languageSelectedChanged
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileLanguagePreferencesEditorActions))
